import React, { useState } from "react";
import chart from '../img/chart.png'
import dashboard from '../img/dashboard.png'
import exit from '../img/exit.png'
import settings from '../img/settings.png'
import coach from '../img/brain.png'
import statistics from '../img/statistics.png'
import upload from '../img/upload.png'
import { useNavigate } from "react-router-dom";
import { supabaseAnon } from "../db";


const SideBar = ({ setPage }) => {
    const navigate = useNavigate();
    const [sidebarOpen, setSidebarOpen] = useState(false);

    const toggleSidebar = () => {
        setSidebarOpen(!sidebarOpen);
    };

    const handleNavigation = (path, page) => {
        navigate(path);
        setPage(page);
        setSidebarOpen(false);
    };

    return (
        <>
            <button 
                className={`sidebar-toggle-btn ${sidebarOpen ? 'open' : ''}`}
                onClick={toggleSidebar}
            >
                ☰
            </button>
            <div className={`sidebar ${sidebarOpen ? 'active' : ''}`}>
                <ul className="sidebar-list">
                    <li title="Dashboard" onClick={() => {
                        handleNavigation('/dashboard', 'dashboard')
                    }}
                        ><img src={dashboard}/>
                    </li>

                    <li onClick={() => {
                        handleNavigation('/gear-figure', 'gear-figure')
                        }} 
                        title="Upload a Laptime">
                        <img src={upload}/>
                    </li>
                    
                    <li onClick={() => {
                        handleNavigation('/lap-time-comparison', 'lap-time-comparison')
                        }} 
                        title="Compare Laptimes">
                        <img src={chart}/>
                    </li>

                    <li onClick={() => {
                        handleNavigation('/ai-coach', 'ai-coach')
                        }} 
                        title="AI Coach">
                        <img src={coach}/>
                    </li>

                    <li onClick={() => {
                        handleNavigation('/settings', 'settings')
                        }} 
                        title="Settings">
                        <img src={settings}/>
                    </li>


                    <li onClick={async () => {
                        const { error } = await supabaseAnon.auth.signOut()

                        if (!error) {
                            navigate('/'); 
                            setPage('landing');
                            setSidebarOpen(false);
                        } else {
                            console.error(error); 
                        }
                    }}><img src={exit}/></li>
                </ul>
            </div>
        </>
    ); 
};

export default SideBar;